import confetti from 'canvas-confetti';

const LUMI_COLOURS = [
  '#0B8A7E', // teal
  '#5EEAD4', // mint
  '#FAC775', // amber
  '#D4A020', // gold
  '#FAFAF6', // cream
  '#A7D9D0', // border hi
  '#059669', // green
];

const EXPERT_COLOURS = ['#FAC775', '#D4A020', '#EF9F27', '#FEF7E0', '#BA7517'];

const CONFIGS = {
  subtle: { particleCount: 35,  spread: 55,  startVelocity: 25, ticks: 60  },
  normal: { particleCount: 80,  spread: 70,  startVelocity: 35, ticks: 80  },
  big:    { particleCount: 150, spread: 100, startVelocity: 45, ticks: 120 },
};

/**
 * celebrate — burst from centre of screen
 * @param {{ intensity?: 'subtle'|'normal'|'big' }} opts
 */
export function celebrate({ intensity = 'normal' } = {}) {
  confetti({
    ...CONFIGS[intensity],
    origin: { y: 0.6 },
    colors: LUMI_COLOURS,
    scalar: 0.9,
    disableForReducedMotion: true,
  });
}

/**
 * celebrateFromElement — burst from a specific DOM element's position
 * @param {Element|null} el
 * @param {{ intensity?: 'subtle'|'normal'|'big' }} opts
 */
export function celebrateFromElement(el, { intensity = 'normal' } = {}) {
  if (!el) return celebrate({ intensity });
  const rect = el.getBoundingClientRect();
  const x = (rect.left + rect.width / 2) / window.innerWidth;
  const y = (rect.top  + rect.height / 2) / window.innerHeight;
  confetti({
    ...CONFIGS[intensity],
    origin: { x, y },
    colors: LUMI_COLOURS,
    scalar: 0.9,
    disableForReducedMotion: true,
  });
}

/**
 * celebrateExpert — gold-only burst for Lumi Expert level
 */
export function celebrateExpert() {
  confetti({
    particleCount: 200,
    spread: 120,
    startVelocity: 50,
    origin: { y: 0.5 },
    colors: EXPERT_COLOURS,
    scalar: 1.1,
    ticks: 150,
    disableForReducedMotion: true,
  });
}

// Alias used in JSX where a button ref is passed
export const celebrateFromButton = celebrateFromElement;
